import { hostApi } from "@/apis/index";
import Vue from 'vue';

const api_trim = `${hostApi}/api/app/trims`;

function getTrimList(params) {
    return Vue.prototype.$http.get(api_trim, { params });
}

function getTrim(id) {
    return Vue.prototype.$http.get(`${api_trim}/${id}`);
}

export {
    getTrimList,
    getTrim,
};
